import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "Avaliação")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Qualidade da ligação", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, "Problemas relatados:", -1)
const _hoisted_8 = { class: "text-paragraph" }

import type { Rating } from "@phurshell/psiapp-frontend-core/domain";


export default /*#__PURE__*/_defineComponent({
  __name: 'Rating',
  props: {
    rating: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_VotingStars = _resolveComponent("VotingStars")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_VotingStars, {
          disabled: "",
          value: _ctx.rating.rating
        }, null, 8, ["value"])
      ]),
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.rating.description || "Nenhum problema relatado"), 1)
    ])
  ]))
}
}

})